export const TWITTER_HANDLE = 'CHANGE_ME';
export const COMPANY_TWITTER = `https://twitter.com/${TWITTER_HANDLE}`;
export const COMPANY_EMAIL = 'CHANGE_ME';
export const COMPANY_EMAIL_LINK = `mailto:${COMPANY_EMAIL}`;
export const EXTERNAL_COMPANY_INSTAGRAM = 'https://www.instagram.com/play.bounce';
export const EXTERNAL_COMPANY_LINKEDIN = 'https://www.linkedin.com/company/playbounce/';
export const EXTERNAL_COMPANY_FACEBOOK = 'https://www.facebook.com/profile.php?id=61550012866223';
export const COMPANY_INSTAGRAM = '/instagram';
export const COMPANY_LINKEDIN = '/linkedin';
export const COMPANY_FACEBOOK_PAGE = '/facebook';
export const APP_STORE =
  'https://apps.apple.com/us/app/advantage-tennis-pickleball/id6444242260?platform=iphone';
export const PLAY_STORE = 'https://play.google.com/store/apps/details?id=love.advantage.app';
export const DISCORD_LINK = 'https://discord.gg/d6kEcnxMvt';

export const APP_DEV = 'development';
export const APP_STAGING = 'staging';
export const APP_PRODUCTION = 'production';
export const MOBILE_PLATFORM = 'mobile';
